import AssessmentIcon from '@mui/icons-material/Assessment';
import DeleteIcon from "@mui/icons-material/Delete";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import React from "react";
import { useTranslation } from "react-i18next";
import Filter from 'utils/Filter';

import { asTitle } from "utils/Utils";

interface TrajectoryActionBarProps {
	hasSelection: boolean;

	onCreate(): void;
	onDelete(): void;
	onGenerateExtract(): void;
	onFilter(value: string): void;
}

const TrajectoryActionBar: React.FC<TrajectoryActionBarProps> = (props: TrajectoryActionBarProps) => {
	const { t } = useTranslation();

	return <Grid container alignItems="center">
		<Grid item xs={4}>
			<Grid container>
				<Grid item>
					<Tooltip title={asTitle(t("newDocument", { document: "trajectory" })) ?? ""}>
						<span>
							<IconButton
								id="new-button"
								aria-label="new"
								onClick={(): void => props.onCreate()}
								size="large">
								<InsertDriveFileIcon />
							</IconButton>
						</span>
					</Tooltip>
				</Grid>
				<Divider orientation="vertical" flexItem />
				<Grid item>
					<Tooltip title={asTitle(t("generateExtract")) ?? ""}>
						<span>
							<IconButton
								id="generate-extract-button"
								aria-label="generate-extract"
								onClick={props.onGenerateExtract}
								disabled={props.hasSelection}
								size="large">
								<AssessmentIcon />
							</IconButton>
						</span>
					</Tooltip>
				</Grid>
				<Divider orientation="vertical" flexItem />
				<Grid item>
					<Tooltip title={asTitle(t("delete")) ?? ""}>
						<span>
							<IconButton
								id="delete-button"
								aria-label="delete"
								onClick={props.onDelete}
								disabled={props.hasSelection}
								size="large">
								<DeleteIcon />
							</IconButton>
						</span>
					</Tooltip>
				</Grid>
			</Grid>
		</Grid>
		<Grid item xs={4}>
			<Typography id="title" variant="h5" align="center">
				{asTitle(t("trajectory_other"))}
			</Typography>
		</Grid>
		<Grid item xs={4}>
			<Filter onChange={props.onFilter} />
		</Grid>
	</Grid>;
}

export default TrajectoryActionBar;
